'use strict';

(function (w, body) {
  var version = '202003261552';
  var allCopy = {
    'de': {
      line_1: 'Dieser Artikel wurde aus US-Baumwolle gefertigt:',
      bullet_1: 'Mit moderner Technologie angebaut, um stärkere Fasern zu produzieren. Darum ist sie so weich und gleichzeitig strapazierfähiger.',
      bullet_2: 'Nachhaltig hergestellt, mit innovativen Messsystemen, die den Abbau natürlicher Ressourcen verhindern.',
      line_2: 'Wenn es auf Qualität und Nachhaltigkeit ankommt, entscheiden Sie sich für COTTON USA™. Baumwolle, der die Welt vertraut.'
    },
    'en': {
      line_1: 'This item was made with U.S. cotton:',
      bullet_1: 'Grown using advanced technology to produce stronger fibers so it’s soft yet more durable',
      bullet_2: 'Produced sustainably, with innovative measurement systems that prevent depletion of natural resources',
      line_2: 'If quality and sustainability matter, choose COTTON USA&trade;. The cotton the world trusts.'
    },
    'es': {
      line_1: 'Este producto fue elaborado con algodón de los EE. UU.:',
      bullet_1: 'Cultivado usando tecnología avanzada para producir fibras más resistentes de modo que es suave y a la vez más duradero',
      bullet_2: 'Producido de manera sostenible, con innovadores sistemas de medición para evitar el agotamiento de los recursos naturales',
      line_2: 'Si la calidad y la sostenibilidad importan, elige COTTON USA™, el Algodón en el que el Mundo Confía.'
    },
    'fr': {
      line_1: 'Cet article est fabriqué en coton américain.',
      bullet_1: 'Cultivé au moyen d’une technologie avancée pour produire des fibres à la fois douces, durables et plus résistantes',
      bullet_2: 'Produit de manière durable, en utilisant des systèmes de mesures novateurs qui préviennent l’épuisement des ressources naturelles',
      line_2: 'Si vous attachez de l’importance à la qualité et à la durabilité, faites le choix de COTTON USA™. Le coton en lequel le monde a confiance.'
    },
    'id': {
      line_1: 'Produk ini dibuat dengan kapas AS',
      bullet_1: 'Dibudidayakan menggunakan teknologi canggih untuk memproduksi serat yang lebih kuat, sehingga lebih lembut namun lebih tahan lama',
      bullet_2: 'Diproduksi secara berkelanjutan, dengan sistem pengukuran inovatif yang mencegah habisnya sumber daya alam',
      line_2: 'Jika Anda mementingkan kualitas dan keberlanjutan, pilihlah COTTON USA™. Kapas yang dipercaya dunia.'
    },
    'it': {
      line_1: 'Questo prodotto è stato realizzato in cotone americano:',
      bullet_1: 'Coltivato con l’impiego di una tecnologia avanzata per produrre fibre più resistenti, è morbido e al tempo stesso più resistente',
      bullet_2: 'Prodotto in modo sostenibile, con sistemi di misurazione innovativi che prevengono l\'esaurimento delle risorse naturali',
      line_2: 'Se la qualità e la sostenibilità sono importanti, scegli COTTON USA ™. Il cotone di cui il mondo si fida.'
    },
    'bn': {
      line_1: 'এই পণ্যগুলো ইউএস কটন থেকে তৈরি:',
      bullet_1: 'উন্নত প্রযুক্তি ব্যবহার করে উৎপাদন করা যাতে দৃঢ়তর তন্তু তৈরি হয় তাই এটা নরম হলেও আরও বেশি স্থায়ী',
      bullet_2: 'স্থায়ীত্ব উৎপাদন করা হয়েছে, উদ্ভাবনী পরিমাপ ব্যবস্থার মাধ্যমে যা প্রাকৃতিক সম্পদের অপচয় রোধ কর',
      line_2: 'Iযদি মান এবং স্থায়ীত্ব বিবেচ্য হয়, কটন ইউএসএ™ বেছে নিন। বিশ্বের আস্থা অর্জনকারী তুলা।'
    },
    'ja': {
      line_1: 'こちらのアイテムにはアメリカ綿が使用されています：',
      bullet_1: '強い繊維を作るために最先端技術を使って栽培されており、柔らかいけれども丈夫さも備えています。',
      bullet_2: 'サステナビリティに配慮して生産され、革新的な計測システムにより天然資源の枯渇を防ぎます。',
      line_2: '品質とサステナビリティを大切に考えるなら、COTTON USA™をお選びください。世界で信頼されるコットンです。'
    },
    'ko': {
      line_1: '이 상품의 원료로 사용된 미국산 코튼은:',
      bullet_1: '더욱 탄탄한 섬유를 위해 첨단 기술을 사용하여 재배되어 부드러우면서도 내구성이 뛰어납니다.',
      bullet_2: '천연자원의 고갈을 막는 혁신적인 측정 시스템을 사용하여 지속가능한 방법으로 생산됩니다',
      line_2: 'I품질과 지속가능성이 중요하다고 생각하신다면 COTTON USA™을 선택하세요. 세계가 신뢰하는 코튼.'
    },
    'tr': {
      line_1: 'Bu ürün Amerikan pamuğundan üretilmiştir:',
      bullet_1: 'Yumuşaklığından ödün vermeyen daha güçlü ve dayanıklı iplik elde etmeyi sağlayan gelişmiş teknoloji ile üretilmektedir.',
      bullet_2: 'Daha yeşil ve çevre dostu bir dünya için doğal kaynakları tüketmeyen yenilikçi ölçüm sistemleri ve daha az su kullanımı içeren sürdürülebilir üretim yöntemleriyle üretilmektedir.',
      line_2: 'Kalite ve sürdürülebilirlik sizin için önemliyse Dünyanın Güvendiği Pamuk olan COTTON USA™’yi seçin.'
    },
    'vi': {
      line_1: 'Sản phẩm này được làm từ bông Mỹ:',
      bullet_1: 'Được trồng với công nghệ tiên tiến giúp cho xơ bông chắc hơn và mềm mịn hơn nhưng vẫn rất bền bỉ',
      bullet_2: 'Được trồng một cách bền vững, với hệ thống đo lường tiên tiến giúp ngăn ngừa sự cạn kiện của các nguồn tài nguyên thiên nhiên',
      line_2: 'Nếu chất lượng và bền vững là quan trọng, hãy chọn COTTON USA™, Bông được thế giới tin dùng.'
    },
    'zh_cn': {
      line_1: '该商品采用美棉制成。',
      bullet_1: '采用先进技术种植，可生产更强韧的纤维，既柔软又耐久。',
      bullet_2: '以可持续的方式生产，创新的测量系统可以防止自然资源枯竭',
      line_2: '如果质量和可持续性对您很重要，请选择COTTON USA™。全球信赖美棉。'
    },
    'zh_tw': {
      line_1: '此商品原料是美國棉花',
      bullet_1: '美國棉採用先進的種植技術，因此纖維柔軟、強力佳更耐洗',
      bullet_2: '美國棉是環保的，使用先進的測量系統，避免耗盡自然資源。',
      line_2: '為了品質和環保,選擇值得全球信賴的美國棉商標'
    }
  },
      islocal = checkIflocal(),
      baseUrl = islocal ? '/' : 'https://tag.cottonusa.org/',
      supported_languages = ['de', 'en', 'es', 'fr', 'id', 'it', 'bn', 'ja', 'ko', 'tr', 'vi', 'zh_cn', 'zh_tw'],
      default_language = 'en',
      default_element_name = 'cct',
      hasTouch = null,
      $ = document.querySelector,
      $a = document.querySelectorAll;

  var language = getLanguage();

  function getLanguage() {
    for (var i = 0, l = navigator.languages.length; i < l; i++) {
      // Exact Match
      if (supported_languages.indexOf(navigator.languages[i]) !== -1) {
        return navigator.languages[i];
      }

      // Close Match
      var userPreferedLanguage = navigator.languages[i].split('-')[0];
      if (supported_languages.indexOf(userPreferedLanguage) !== -1) {
        return userPreferedLanguage;
      }
    }
    return default_language;
  };

  function setLocal(newLanguage) {
    if (newLanguage !== null && supported_languages.indexOf(newLanguage) !== -1) {
      language = newLanguage;
    }
  }

  function checkIflocal() {
    if (window.location.hostname.match(/localhost|192\.168/)) {
      return true;
    } else {
      return false;
    }
  }

  function loadStyles() {
    var cssId = 'cctCss'; // you could encode the css path itself to generate id..
    if (!document.getElementById(cssId)) {
      var head = document.getElementsByTagName('head')[0];
      var link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = baseUrl + 'assets/styles/main.css?v=' + version;
      link.media = 'all';
      head.appendChild(link);
    }
  }

  function buildTemplate() {
    var htmlCct = '';
    var cctYoutubeId = 'tDJtFxXMcHE';
    var copy = allCopy[language];

    var template = '<div id="cct-popup-cont" style="display: none;">\n      <div class="cct-container">\n        <div class="cct-title"></div>\n        <button href="javascript: void(0)" class="cct-close">X</button>\n\n        <div class="cct-video-wrapper">\n          <video controls id="cct-video" preload="none" playsinline>\n            <source src="' + baseUrl + 'assets/videos/' + language + '_video_001.mp4" type="video/mp4">\n          </video>\n        </div>\n        <div class="cct-wrapper">\n          <div class="cct-description">\n            <p class="cct-no-space">' + copy.line_1 + '</p>\n            <ul>\n            <li>' + copy.bullet_1 + '</li>\n            <li>' + copy.bullet_2 + '</li>\n            </ul>\n            <p>' + copy.line_2 + '</p>\n          </div>\n        </div>\n      </div>\n    </div>';
    // <iframe id="cct-video" width="100%" height="315" src="https://www.youtube.com/embed/+cctYoutubeId+?enablejsapi=1&version=3&playerapiid=ytplayer" frameborder="0" allowfullscreen></iframe>
    return template;
  }

  function wordWrap(targetStr) {
    var element = document.querySelector(targetStr);

    if (!element) {
      error.log('can\'t find element ' + targetStr + ' on the page.');
    }

    var treeWalker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, null),
        nodes = [],
        node,
        cottonStr = 'COTTON USA',
        cctText;
    // push all nodes to an array to make the iteration static.
    while (node = treeWalker.nextNode()) {
      nodes.push(node);
    }

    while (node = nodes.pop()) {

      // debugger;
      var p = node.parentNode;

      // Skip cct elements
      if (p.tagName.toLowerCase() === default_element_name || p.parentNode.tagName.toLowerCase() === default_element_name) {
        continue;
      }

      var text = node.nodeValue;
      var next = node.nextSibling;
      var index = text.toUpperCase().indexOf(cottonStr);
      var once = false;

      while (index != -1) {
        // text
        node.nodeValue = text.slice(0, index);
        cctText = text.slice(index, index + cottonStr.length);
        text = text.slice(index + cottonStr.length);

        // create span
        var span = document.createElement(default_element_name);
        var word;
        if (next === null) {
          word = p.appendChild(span);
        } else {
          // Todo: fix this it doesn't work.
          try {
            word = p.insertBefore(span, next);
          } catch (e) {
            console.log(e);
          }
        }
        word.appendChild(document.createTextNode(cctText));

        // create element after
        var after = document.createTextNode(text);
        if (next === null) {
          p.appendChild(after);
        } else {
          p.insertBefore(span, after);
        }

        // update current node to be the last part of the text
        node = after;

        // See if there are any other cottonStr
        index = text.toUpperCase().indexOf(cottonStr);
      }
    }
  }

  function open() {
    document.querySelectorAll('#cct-popup-cont, .cct-overlay').forEach(function (elem) {
      elem.style.display = 'block';
      elem.classList.add('show');
    });
    document.querySelector('#cct-video').play();
    document.querySelector('html').classList.add('cct-stopscroll');
    ping();
  }

  function close() {
    document.querySelectorAll('#cct-popup-cont, .cct-overlay').forEach(function (elem) {
      elem.classList.remove('show');
    });
    var event = new Event('pause');
    document.querySelector('#cct-video').pause();
    document.querySelector('html').classList.remove('cct-stopscroll');
  }

  function loadHtml() {
    // overlay + template
    var htmlCct = buildTemplate();
    body.insertAdjacentHTML('beforeend', '<div class="cct-overlay" style="display: none;"></div><div class="cct-ping" style="display: none;"></div>' + htmlCct);
  }

  function attachEvents() {
    document.querySelectorAll('.cct-close, .cct-overlay').forEach(function (elem) {
      elem.addEventListener('click', close);
    });

    document.querySelectorAll('.cct-trigger').forEach(function (elem) {
      elem.addEventListener('click', open);
    });

    document.querySelectorAll('cct').forEach(function (elem) {
      elem.addEventListener('click', open);
    });
  }

  /*
   * We are just tracking if the page was open, no personal information is collected.
   */
  function ping() {
    var pingElement = document.querySelector('.cct-ping');
    var img = document.createElement('img');
    var random = 1 * new Date();
    img.src = baseUrl + 'stats/ping.php?v=' + random;
    pingElement.appendChild(img);
  }

  function init(targetStr) {
    var newLanguage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    setLocal(newLanguage);
    loadStyles();
    wordWrap(targetStr);
    loadHtml();
    attachEvents();
    // IF not create.
  }

  function performAction(action, option1) {
    var option2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    switch (action) {
      case 'init':
        init(option1, option2);
        break;
      case 'setLocal':
        setLocal(option1);
        break;
      case 'loadStyles':
        loadStyles();
        break;
      case 'wordWrap':
        wordWrap(option1);
        break;
      case 'loadHtml':
        loadHtml();
        break;
      case 'attachEvents':
        attachEvents();
        break;
      default:
        console.error('invalide action');
    }
  }

  function callAction(argArray) {
    if (argArray.length === 0) {
      console.log('no parameters found');
    } else if (argArray.length === 1) {
      performAction(argArray[0]);
    } else if (argArray.length === 2) {
      performAction(argArray[0], argArray[1]);
    } else if (argArray.length === 3) {
      performAction(argArray[0], argArray[1], argArray[2]);
    } else {
      console.log('no parameters found');
    }
  }

  function parseActionsInCusObject() {
    while (w.cct.q && w.cct.q.length > 0) {
      var argArray = w.cct.q.shift();
      callAction(argArray);
    }
  }

  function updateObjectToCallDirectly() {
    w.cct = function () {
      callAction(arguments);
    };
  }

  parseActionsInCusObject();
  updateObjectToCallDirectly();
})(window, document.body);